import type { HierarchyNodeData } from './HierarchyNavigator';

export const hierarchyNodeUtils = {
  getAllChildren: (node: HierarchyNodeData): HierarchyNodeData[] => {
    if (!node.children || node.children.length === 0) {
      return [];
    }
    const result: HierarchyNodeData[] = [];
    for (const child of node.children) {
      result.push(child);
      result.push(...hierarchyNodeUtils.getAllChildren(child));
    }
    return result;
  },
};
